import { Button, IButtonProps } from "../../../../components/Buttons/Button/Button";
import { useDispatch, useSelector } from "../../../../hooks";
import { IQuizCurrentState, QuizQuestionComplexity, QuizQuestionComplexityNames, QuizStatus } from "../../../../redux/quizzes";
import { abortQuiz } from "../../../../redux/quizzes/abort-quiz.handler";
import { finishQuiz } from "../../../../redux/quizzes/finish-quiz.handler";
import styles from "./QuizFinishBlock.module.scss";
import { AppContext } from "../../../../components/Menu/MenuButton";
import { TicketsPanel } from "../../../../components/TicketsPanel/TicketsPanel";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ActionsContext } from "../../../ActionsPage/ACtionsRoutes";

const isExpired = (quiz: IQuizCurrentState) => quiz.status === QuizStatus.Expired;

const calcDegree = (quiz: IQuizCurrentState): QuizQuestionComplexity => {
    const percent = quiz.rightAsnwersCount / quiz.totalQuestionsCount;
    
    let degree: QuizQuestionComplexity;
    if (percent < 0.2)
        degree = QuizQuestionComplexity.None;
    else if (percent < 0.5)
        degree = QuizQuestionComplexity.Base;
    else if (percent <= 0.8)
        degree = QuizQuestionComplexity.Advanced;
    else 
        degree = QuizQuestionComplexity.Expert;

    return degree;
}

export const QuizFinishBlock = () => {
    const [degree, setDegree] = useState(QuizQuestionComplexity.None);

    const { quiz, ticketsRewards } = useSelector(store => store.quiz);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!quiz || quiz.rightAsnwersCount === 0 || isExpired(quiz))
            return;
        
        setDegree(calcDegree(quiz));
    }, [quiz?.rightAsnwersCount, isExpired, calcDegree, setDegree]);

    if (!quiz) {
        navigate(`/${AppContext.Actions}/${ActionsContext.Tasks}`, { replace: true });
        return <></>;
    }

    const getDegreeName = () => QuizQuestionComplexityNames[degree];    

    const getText = () => {
        if (isExpired(quiz))
            return 'Вы отсутствовали более 30 минут';
        
        return (
            <p className={styles.earnText}>
                { `Вы ответили правильно на ${quiz.rightAsnwersCount} из ${quiz.totalQuestionsCount} вопросов.` }
            </p>
        );
    }

    const finish = () => {
        dispatch(finishQuiz());
    }

    const onDropQuiz = () => {
        dispatch(abortQuiz());
    }

    const getButton = () => {        
        let sets: IButtonProps = quiz.status === QuizStatus.Expired
            ? { handler: onDropQuiz, caption: 'Закрыть', type: 'orange' }
            : { handler: finish, caption: 'Завешить викторину', type: 'orange' };

        return (
            <div className={styles.button}>
                <Button {...sets} />
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.resultContainer}>
                <div className={styles.resultBlock}>
                    {
                        quiz.rightAsnwersCount > 0 && !isExpired(quiz)
                            ? <h2 className={styles.resultTitleGreen}>Поздравляем!</h2>
                            : <h2 className={styles.incorrectTitle}>Викторина завершена</h2>
                    }

                    { getText() }

                    { quiz.rightAsnwersCount > 0 && !isExpired(quiz) && degree !== QuizQuestionComplexity.None &&
                        <>
                            <p className={styles.correctAnswerLabel}>Ваш уровень знаний</p>
                            <p className={styles.correctAnswer}>{`“${getDegreeName()}”`}</p>
                        </>
                    }

                    { degree !== QuizQuestionComplexity.None &&
                        <>
                            <p className={styles.correctAnswerLabel}>Получено билетов</p>
                            <TicketsPanel { ...ticketsRewards[degree] } />
                        </>
                    }
                </div>
            </div>

            { getButton() }
        </div>
    );
};
